import { SuamRole } from '../../utils';

export const mockRoleMatrix = {
  box: {
    modelKey: 'box-default',
    id: 'ba7b8238-ed80-43e3-b45d-4bb52f17d1c9',
    featurePermissions: {
      storeInventoryCount: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: 'R',
        },
        isActive: true,
      },
      transactionSearch: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          storeEmployee: null,
          admin: 'R',
          globalSecurity: null,
          other: null,
        },
        isActive: true,
      },
      transactionSearchPage: {
        permissions: {
          storeController: 'CRUD',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: '',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: '',
          regionalManager: '',
          regionalOther: '',
        },
        isActive: true,
      },
      employees: {
        permissions: {
          storeController: 'RU',
          storeManager: 'RU',
          storeVisual: null,
          departmentManager: null,
          storeEmployee: null,
          admin: 'RU',
          globalSecurity: 'R',
          other: null,
        },
        isActive: true,
      },
      employeesAndRolesPage: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: '',
          regionalManager: '',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      avatarManagementPage: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      kpiTargetsPage: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      soldProductsPage: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      productIndexSubindex: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      chatBoxPage: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      topSellingGarmentsWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      newAppCustomersWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      newMembersWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      shareOfReceiptWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      salesPerformanceWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      assetManagementWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },

      helpASaleWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      conversionRateWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      salesInsightWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      effectiveHoursWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      areaComparisonWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      scoShareOfReceipt: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      avgPiecesPerReceiptWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      avgPurchasePerReceiptWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      takt1Widget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      sptWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      queueLengthWidget: {
        permissions: {
          storeController: '',
          storeManager: '',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: '',
          areaController: '',
          areaVisual: '',
          areaHR: '',
          countryController: '',
          salesMarketController: '',
          regionalController: '',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: '',
          regionalStoreOperation: '',
          salesMarketManager: '',
          regionalManager: '',
          regionalOther: '',
        },
        isActive: true,
      },
      queueLengthTillViewWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      customerFeedBackWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      personalSettings: {
        permissions: {
          storeController: 'CRUD',
          storeManager: 'CRUD',
          storeVisual: 'CRUD',
          departmentManager: 'CRUD',
          other: 'CRUD',
          areaManager: 'CRUD',
          areaController: 'CRUD',
          areaVisual: 'CRUD',
          areaHR: 'CRUD',
          countryController: 'CRUD',
          salesMarketController: 'CRUD',
          regionalController: 'CRUD',
          salesMarketHR: 'CRUD',
          regionalHR: 'CRUD',
          salesMarketVisual: 'CRUD',
          regionalVisual: 'CRUD',
          salesMarketOperation: 'CRUD',
          regionalStoreOperation: 'CRUD',
          salesMarketManager: 'CRUD',
          regionalManager: 'CRUD',
          regionalOther: 'CRUD',
          globalRole: 'CRUD',
        },
        isActive: true,
      },
      kpiTargets: {
        permissions: {
          storeController: 'RU',
          storeManager: 'CRUD',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'CRUD',
          areaController: 'CRUD',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      areaCaps: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'RU',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      lockTargets: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'CRUD',
          areaController: 'CRUD',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      employeePermissions: {
        permissions: {
          storeController: 'RU',
          storeManager: 'RU',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'RU',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      highlightWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'CRUD',
          areaController: 'CRUD',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      bopisWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: '',
          regionalStoreOperation: '',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      financialPlanned: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: '',
          regionalStoreOperation: '',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      financialBudget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: '',
          regionalStoreOperation: '',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      blacklistPermissionsForArea: {
        permissions: {
          storeController: '',
          storeManager: '',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'CRUD',
          areaController: 'CRUD',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      orisCustomerWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      rfidApprovalsWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      profitAndLossPage: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: '',
          regionalStoreOperation: '',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      customerEngagementWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      rfidSalesWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      stockCountWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      stockAccuracyWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      efficiencyWidget: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      currencyConverter: {
        permissions: {
          storeController: '',
          storeManager: '',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: false,
      },
      salesOverview: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      membersOverview: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      conversionRateOverview: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      queueAndCustomerOverview: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      efficiencyOverview: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      rfidOverview: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: 'R',
          departmentManager: 'R',
          other: 'R',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: 'R',
          areaHR: 'R',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: 'R',
          regionalHR: 'R',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
          globalRole: 'R',
        },
        isActive: true,
      },
      budgetAndPlanOverview: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      kpiTargetsOverview: {
        permissions: {
          storeController: 'R',
          storeManager: 'R',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: 'R',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: '',
          regionalVisual: '',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: '',
          globalRole: '',
        },
        isActive: true,
      },
      salesAnalysisPage: {
        permissions: {
          storeController: '',
          storeManager: '',
          storeVisual: '',
          departmentManager: '',
          other: '',
          areaManager: '',
          areaController: 'R',
          areaVisual: '',
          areaHR: '',
          countryController: 'R',
          salesMarketController: 'R',
          regionalController: 'R',
          salesMarketHR: '',
          regionalHR: '',
          salesMarketVisual: 'R',
          regionalVisual: 'R',
          salesMarketOperation: 'R',
          regionalStoreOperation: 'R',
          salesMarketManager: 'R',
          regionalManager: 'R',
          regionalOther: 'R',
        },
        isActive: true,
      },
    },
    roleManagement: {
      departmentManager: {
        departmentManager: 'R',
        storeController: null,
        storeEmployee: 'RU',
        storeManager: null,
        storeVisual: 'R',
        admin: null,
        fieldTechnician: 'R',
        other: 'R',
      },
      storeController: {
        departmentManager: null,
        storeController: 'R',
        storeEmployee: 'RU',
        storeManager: null,
        storeVisual: 'R',
        admin: null,
        fieldTechnician: 'R',
        other: 'R',
      },
      storeManager: {
        departmentManager: 'RU',
        storeController: 'RU',
        storeEmployee: 'RU',
        storeManager: 'R',
        storeVisual: 'RU',
        admin: null,
        fieldTechnician: 'R',
        other: 'RU',
      },
      storeVisual: {
        departmentManager: null,
        storeController: null,
        storeEmployee: null,
        storeManager: null,
        storeVisual: null,
        admin: null,
        fieldTechnician: null,
        other: null,
      },
      storeEmployee: {
        departmentManager: null,
        storeController: null,
        storeEmployee: null,
        storeManager: null,
        storeVisual: null,
        admin: null,
        fieldTechnician: null,
        other: null,
      },
      admin: {
        departmentManager: 'R',
        storeController: 'R',
        storeEmployee: 'R',
        storeManager: 'RU',
        storeVisual: 'R',
        admin: 'R',
        fieldTechnician: 'RU',
        other: 'R',
      },
    },
    _rid: 'AG4qAKuRHUoWAAAAAAAAAA==',
    _self: 'dbs/AG4qAA==/colls/AG4qAKuRHUo=/docs/AG4qAKuRHUoWAAAAAAAAAA==/',
    _etag: '"1600c1ab-0000-0d00-0000-683019030000"',
    _attachments: 'attachments/',
    _ts: 1747982595,
  },
};

export const mockRoles: SuamRole[] = ['SM', 'SC', 'SV', 'EV', 'FM'];
